/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {upsertShiftSchedules} from '../api'

export const useMutationUpsertShiftSchedules = createReactQueryMutationHook('upsertShiftSchedules', upsertShiftSchedules)
